import styled, { css } from 'styled-components';
import { ChevronIcon } from '@sainsburys-tech/bolt-icons';
import { Image } from '@sainsburys-tech/bolt';
import { themeContract } from './Footer.theme.contract';
var Footer = styled.footer.withConfig({
  displayName: "Footerstyles__Footer",
  componentId: "sc-1ins9hy-0"
})(["overflow:hidden;border-top:1px solid ", ";", ""], function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.type === 'default' ? css(["background:", ";"], props.theme.channel === 'argos' ? "".concat(props.theme.color.monochrome.lighter) : "".concat(props.theme.color.monochrome.white)) : css(["padding-top:15px;text-align:center;border-top:1px solid ", ";"], props.theme.color.monochrome.light);
});
var SectionToggle = styled.input.withConfig({
  displayName: "Footerstyles__SectionToggle",
  componentId: "sc-1ins9hy-1"
})(["display:none;"]);
var AccordionTitle = styled.label.withConfig({
  displayName: "Footerstyles__AccordionTitle",
  componentId: "sc-1ins9hy-2"
})(["color:", ";margin:15px 0;font-size:", ";font-weight:700;display:flex;justify-content:space-between;"], function (props) {
  return props.theme.color.monochrome.darker;
}, function (props) {
  return props.theme.font.size['display-1'];
});
var Arrow = styled(ChevronIcon).withConfig({
  displayName: "Footerstyles__Arrow",
  componentId: "sc-1ins9hy-3"
})(["", ":checked + label > &{transform:rotate(180deg);}"], SectionToggle);
var SectionContent = styled.div.withConfig({
  displayName: "Footerstyles__SectionContent",
  componentId: "sc-1ins9hy-4"
})(["max-height:0px;overflow:hidden;transition:max-height 0.25s ease-in-out;", ":checked + label + &{max-height:100vh;}"], SectionToggle); // PRIMARY SECTION

var Primary = styled.div.withConfig({
  displayName: "Footerstyles__Primary",
  componentId: "sc-1ins9hy-5"
})(["padding:20px 0 20px;border-bottom:1px solid ", ";button{margin-bottom:15px;}@media only screen and (min-width:", "){padding:10px 0 30px;}"], function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.theme.size.breakpoint['min-width'].sm;
});
var PrimaryMobileWrapper = styled.div.withConfig({
  displayName: "Footerstyles__PrimaryMobileWrapper",
  componentId: "sc-1ins9hy-6"
})(["width:100%;"]);
var PrimaryTitle = styled.h4.withConfig({
  displayName: "Footerstyles__PrimaryTitle",
  componentId: "sc-1ins9hy-7"
})(["color:", ";margin:30px 0;font-size:", " !important;"], function (props) {
  return props.theme.color.monochrome.darker;
}, function (props) {
  return props.theme.font.size['display-1'];
});
var PrimaryLink = styled.a.withConfig({
  displayName: "Footerstyles__PrimaryLink",
  componentId: "sc-1ins9hy-8"
})(["padding:0 0 12px;display:block;text-decoration:none;color:", ";&:hover,&:active{text-decoration:underline;}@media screen and (min-width:", "){padding:6px 0 10px;}"], function (props) {
  return props.theme.color.monochrome.darker;
}, function (props) {
  return props.theme.size.breakpoint['min-width'].md;
}); // SECONDARY SECTION

var SecondaryFooter = styled.div.withConfig({
  displayName: "Footerstyles__SecondaryFooter",
  componentId: "sc-1ins9hy-9"
})(["& > div:nth-child(odd){@media only screen and (min-width:", "){border-right:1px solid ", ";}}& > div:nth-child(odd) > div{margin-left:auto;margin-right:0;}& > div:nth-child(even) > div{margin-left:0;margin-right:auto;}"], function (props) {
  return props.theme.size.breakpoint['min-width'].md;
}, function (props) {
  return props.theme.color.monochrome.light;
});
var SecondaryFooterColumn = styled.div.withConfig({
  displayName: "Footerstyles__SecondaryFooterColumn",
  componentId: "sc-1ins9hy-10"
})(["border-bottom:1px solid ", ";width:100%;@media only screen and (min-width:", "){margin-left:0px;margin-right:0px;flex-basis:50%;max-width:50%;}"], function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.theme.size.breakpoint['min-width'].md;
});
var SecondaryFooterItem = styled.div.withConfig({
  displayName: "Footerstyles__SecondaryFooterItem",
  componentId: "sc-1ins9hy-11"
})(["padding:0 0 30px;text-align:center;overflow:hidden;@media only screen and (min-width:", "){height:145px;max-width:600px;}"], function (props) {
  return props.theme.size.breakpoint['min-width'].md;
});
var Title = styled.strong.withConfig({
  displayName: "Footerstyles__Title",
  componentId: "sc-1ins9hy-12"
})(["color:", ";width:100%;display:block;padding:30px 0 15px;text-align:center;font-size:", ";"], function (props) {
  return props.theme.color.monochrome.darker;
}, function (props) {
  return props.theme.font.size.base;
}); // BRAND SECTION

var Brand = styled.div.withConfig({
  displayName: "Footerstyles__Brand",
  componentId: "sc-1ins9hy-13"
})(["text-align:center;padding:25px 20px 0;background:", ";"], function (props) {
  return props.theme.color.monochrome.white;
});
var BrandRow = styled.div.withConfig({
  displayName: "Footerstyles__BrandRow",
  componentId: "sc-1ins9hy-14"
})(["display:flex;flex-wrap:nowrap;justify-content:center;align-items:center;"]);
var BrandWrapper = styled.div.withConfig({
  displayName: "Footerstyles__BrandWrapper",
  componentId: "sc-1ins9hy-15"
})(["display:flex;flex-wrap:wrap;justify-content:center;max-width:309px;margin:0 auto;flex-direction:row;div:last-child{margin-top:12px;}@media only screen and (min-width:", "){flex-wrap:nowrap;max-width:458px;div:last-child{margin-top:0;}}"], function (props) {
  return props.theme.size.breakpoint['min-width'].sm;
});
var BrandTitle = styled.strong.withConfig({
  displayName: "Footerstyles__BrandTitle",
  componentId: "sc-1ins9hy-16"
})(["color:", ";width:100%;padding:10px 0;display:flex;flex-direction:row;margin:0 auto;max-width:394px;& > svg{width:117px;}&:before,&:after{content:'';flex:1 1;border-bottom:1px solid ", ";margin:auto;}&:before{margin-right:15px;}&:after{margin-left:15px;}@media only screen and (min-width:", "){max-width:458px;}"], function (props) {
  return props.theme.color.monochrome.base;
}, function (props) {
  return props.theme.color.monochrome.base;
}, function (props) {
  return props.theme.size.breakpoint['min-width'].sm;
});
var BrandImage = styled.a.withConfig({
  displayName: "Footerstyles__BrandImage",
  componentId: "sc-1ins9hy-17"
})(["svg,img{width:100%;margin:0 15px;", "}"], function (props) {
  switch (props.brand) {
    case 'habitat':
      return 'width: 90px; margin-bottom: 5px;';

    case 'sainsburys':
      return 'width: 123px;';

    case 'argos':
      return 'width: 44px;';

    case 'nectar':
      return 'width: 44px;';

    case 'tu':
      return 'width: 42px;';

    default:
      return 'width: 42px;';
  }
}); // SERVICE SECTION

var SocialAndServiceContainer = styled.div.withConfig({
  displayName: "Footerstyles__SocialAndServiceContainer",
  componentId: "sc-1ins9hy-18"
})(["display:flex;flex-wrap:wrap;align-items:center;max-width:1200px;margin:0 auto;"]);
var ServiceBlock = styled.div.withConfig({
  displayName: "Footerstyles__ServiceBlock",
  componentId: "sc-1ins9hy-19"
})(["margin:0 auto;max-width:300px;@media only screen and (min-width:", "){padding-bottom:20px;}"], function (props) {
  return props.theme.size.breakpoint['min-width'].md;
});
var PaymentImage = styled(Image).withConfig({
  displayName: "Footerstyles__PaymentImage",
  componentId: "sc-1ins9hy-20"
})(["display:inline-flex;border:1px solid ", ";border-radius:2px;padding:0;margin:5px;"], function (props) {
  return props.theme.color.monochrome.lighter;
}); // SOCIAL APP SECTION

var SocialAppLink = styled.a.withConfig({
  displayName: "Footerstyles__SocialAppLink",
  componentId: "sc-1ins9hy-21"
})(["display:inline-flex;align-items:center;border-radius:50%;padding:9px;margin:0 5px;vertical-align:middle;&:hover,&:active{background-color:", ";}"], function (props) {
  return props.theme.color.monochrome.lighter;
});
var SocialAppLinkBottom = styled.a.withConfig({
  displayName: "Footerstyles__SocialAppLinkBottom",
  componentId: "sc-1ins9hy-22"
})(["", ""], function (props) {
  return css(["", " ", ""], props.google && css(["display:flex;justify-content:flex-start;img{width:134px;height:38px;text-align:left;}"]), props.apple && css(["display:flex;justify-content:flex-end;img{width:134px;height:38px;text-align:right;}"]));
}); // RETURNS SECTION

var ReturnsText = styled.p.withConfig({
  displayName: "Footerstyles__ReturnsText",
  componentId: "sc-1ins9hy-23"
})(["padding:0 24px;font-size:15px;> a{white-space:nowrap;}@media only screen and (min-width:", "){padding:0;max-width:340px;margin:0 auto;}"], function (props) {
  return props.theme.size.breakpoint['min-width'].md;
}); // LEGAL SECTION

var Legal = styled.div.withConfig({
  displayName: "Footerstyles__Legal",
  componentId: "sc-1ins9hy-24"
})(["padding:15px 15px 30px;text-align:center;background:", ";color:", ";@media only screen and (min-width:", "){padding:30px 15px;}", ""], function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return props.theme.color.monochrome.darker;
}, function (props) {
  return props.theme.size.breakpoint['min-width'].md;
}, function (props) {
  return css(["", ""], props.variant === 'default' ? css(["a{text-decoration:none;}"]) : css(["a,button{text-decoration:underline;color:", ";&:hover,&:active{color:", ";text-decoration:underline;}}"], props.theme.color.palette[themeContract[props.theme.channel].legal.color], props.theme.color.palette[themeContract[props.theme.channel].legal.colorHover]));
});
var LegalLink = styled.a.withConfig({
  displayName: "Footerstyles__LegalLink",
  componentId: "sc-1ins9hy-25"
})(["padding:3px 5px;display:inline-block;border:inherit;background:none;font:inherit;text-decoration:none !important;color:", "!important;&:hover,&:active{text-decoration:underline !important;}& + &::before{border-left:2px solid ", ";content:'';display:inline-block;height:15px;margin-right:10px;}"], function (props) {
  return props.theme.color.monochrome.darker;
}, function (props) {
  return props.theme.color.monochrome.light;
});
var LegalText = styled.small.withConfig({
  displayName: "Footerstyles__LegalText",
  componentId: "sc-1ins9hy-26"
})(["display:block;max-width:", ";margin:0 auto;line-height:normal;color:", ";& a[href^='tel']{color:", "!important;text-decoration:inherit !important;font-weight:normal !important;pointer-events:none !important;}"], function (props) {
  return props.theme.size.breakpoint['max-width'].lg;
}, function (props) {
  return props.theme.color.monochrome.darker;
}, function (props) {
  return props.theme.color.monochrome.darker;
});
var LegalCopyRightText = styled.p.withConfig({
  displayName: "Footerstyles__LegalCopyRightText",
  componentId: "sc-1ins9hy-27"
})(["margin-top:20px;"]);
var LegalPayPalLogo = styled.div.withConfig({
  displayName: "Footerstyles__LegalPayPalLogo",
  componentId: "sc-1ins9hy-28"
})(["width:66px;min-width:66px;margin:0 auto;margin-left:20px;@media (max-width:768px){margin:20px auto 0px auto;}"]);
var LegalPaypalLogoAPR = styled.div.withConfig({
  displayName: "Footerstyles__LegalPaypalLogoAPR",
  componentId: "sc-1ins9hy-29"
})(["display:flex;flex-direction:row;justify-content:space-between;gap:30px;@media (max-width:768px){flex-direction:column;}"]);
var CheckoutFooter = styled.div.withConfig({
  displayName: "Footerstyles__CheckoutFooter",
  componentId: "sc-1ins9hy-30"
})(["justify-content:center;"]);
var LegalContainer = styled.div.withConfig({
  displayName: "Footerstyles__LegalContainer",
  componentId: "sc-1ins9hy-31"
})(["margin-top:20px;"]);
var LegalRow = styled.div.withConfig({
  displayName: "Footerstyles__LegalRow",
  componentId: "sc-1ins9hy-32"
})(["width:100%;margin-top:20px;"]);
var CheckoutFooterRow = styled.div.withConfig({
  displayName: "Footerstyles__CheckoutFooterRow",
  componentId: "sc-1ins9hy-33"
})(["width:100%;"]);
var CheckoutLogos = styled.div.withConfig({
  displayName: "Footerstyles__CheckoutLogos",
  componentId: "sc-1ins9hy-34"
})(["picture{display:inline-block;max-height:40px;margin:0 5px;max-width:16%;}"]);
var CreditCopy = styled.div.withConfig({
  displayName: "Footerstyles__CreditCopy",
  componentId: "sc-1ins9hy-35"
})(["margin-top:20px;"]);
export { Footer, Arrow, AccordionTitle, SectionToggle, SectionContent, Primary, PrimaryMobileWrapper, PrimaryLink, PrimaryTitle, Brand, BrandWrapper, BrandRow, BrandTitle, BrandImage, SocialAndServiceContainer, SocialAppLink, SocialAppLinkBottom, ServiceBlock, PaymentImage, ReturnsText, SecondaryFooter, SecondaryFooterColumn, SecondaryFooterItem, Title, Legal, LegalLink, LegalText, LegalPayPalLogo, LegalPaypalLogoAPR, LegalContainer, LegalRow, LegalCopyRightText, CheckoutFooter, CheckoutFooterRow, CheckoutLogos, CreditCopy };